import { render, staticRenderFns } from "./CategoryModule.vue?vue&type=template&id=1bd41f42&"
import script from "./CategoryModule.vue?vue&type=script&lang=js&"
export * from "./CategoryModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd41f42')) {
      api.createRecord('1bd41f42', component.options)
    } else {
      api.reload('1bd41f42', component.options)
    }
    module.hot.accept("./CategoryModule.vue?vue&type=template&id=1bd41f42&", function () {
      api.rerender('1bd41f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/categories/CategoryModule.vue"
export default component.exports